import Vue from 'vue'
import axios from 'axios'
import store from 'store'
const theme = VUE_APP_THEME
console.log('theme: ' + theme)

let baseURL = '/'

switch (process.env.NODE_ENV) {
  case 'production':
    switch (theme) {
      case 'theme1' :
        baseURL = 'https://dataroom.groupe-casino.fr/'
        break
      case 'theme2':
        baseURL = 'https://www.dataroom-immo.fr/'
        break
    }
    break
  case 'recette':
    switch (theme) {
      case 'theme1' :
        baseURL = 'https://dataroom-rec.groupe-casino.fr/'
        break
      case 'theme2':
        baseURL = 'https://www-rec.dataroom-immo.fr/'
        break
    }
    break
  case 'development':
    switch (theme) {
      case 'theme1' :
        baseURL = 'http://127.0.0.1:3000/'
        break
      case 'theme2':
        baseURL = 'http://127.0.0.1:3000/'
        break
    }
    break
}

console.log('baseURL ' + baseURL + ' Theme: ' + process.env.THEME + ' Node_Env: ' + process.env.NODE_ENV + ' VueAppTheme: '+VUE_APP_THEME)
const api = axios.create({
  baseURL,
})
api.interceptors.response.use(response => response.data)

Vue.prototype.$api = api
Vue.api = api

// auth token
const token = store.get('token')
if (token) {
  api.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

// api error handling
Vue.mixin({
  methods: {
    // apiError (err, fieldError = {}) {
    apiError (err) {
      let message
      if (typeof err === 'string') {
        // simple string as parameter
        message = err
      } else if (err.rawData !== undefined) {
        // API standard error
        if (err.rawData.code === 500) {
          message = '❌ Application error'
          // TODO track those 500 errors
        } else if (err.rawData.code === 403) {
          message = '🚫 Access Forbidden'
        } else if (err.rawData.code === 404) {
          message = '⚠️ Not Found'
        } else {
          message = '💥 Server error (' + err.name + ')'
          // TODO track errors
        }
        /*
        // catch form-specific error
        if (fieldError[message]) {
          this.errors.add({
            field: fieldError[message],
            msg: message,
          })
          return
        }
        */
      } else if (err.response && err.response.status === 403) {
        message = '🚫 M-Files web access forbidden'
      } else if (err.response && err.response.status === 404) {
        message = '⚠️ Not Found'
      } else {
        // default handler
        message = '💥 There has been an error with the server'
        // TODO track errors
      }
      this.$toast.open({
        message,
        type: 'is-danger',
        position: 'is-bottom',
      })
    },
  },
})

export default api